module.exports = __webpack_public_path__ + "static/assets/43518618bf485e99efcb1009c8061314.png";